/**
 * Presentation models for Operational Readiness.
 * Parents map existing platform state into these views — no business rules here.
 */

export type OperationalStatus =
    | 'ready'
    | 'warning'
    | 'missing'
    | 'blocked'
    | 'informational'
    | 'unknown';

export type OperationalScope = 'organization' | 'platform';

export type OperationalRequirement =
    | 'always_required'
    | 'conditionally_required'
    | 'optional'
    | 'informational';

/** Warning contract: Problem → Impact → Recommended Action (+ optional scope/condition). */
export type OperationalWarningView = {
    problem: string;
    impact: string;
    recommendedAction: string;
    scope?: OperationalScope;
    condition?: string;
};

export type OperationalStatusCardView = {
    key?: string;
    title: string;
    status: OperationalStatus;
    /** Override default label derived from status. */
    statusLabel?: string;
    detail?: string;
    requirement?: OperationalRequirement;
    warnings?: OperationalWarningView[];
};

export const OPERATIONAL_STATUS_LABELS: Record<OperationalStatus, string> = {
    ready: 'Ready',
    warning: 'Warning',
    missing: 'Missing',
    blocked: 'Blocked',
    informational: 'Info',
    unknown: 'Unknown',
};

export function operationalStatusLabel(
    status: OperationalStatus,
    override?: string | null,
): string {
    if (override && override.trim()) {
        return override.trim();
    }
    return OPERATIONAL_STATUS_LABELS[status] ?? OPERATIONAL_STATUS_LABELS.unknown;
}
